import ImageUploader from './ImageUploader.js';

export default ImageUploader;